// Armazenamento no navegador: o quanto o site usa da cota que o navegador reserva para ele.
export type Aparelho = { livre: number | null; total: number | null; anexos: number; usoNavegador?: number; cotaNavegador?: number };

export async function lerAparelho(): Promise<Aparelho> {
  try {
    const e = await navigator.storage?.estimate?.();
    if (e) return { livre: null, total: null, anexos: 0, usoNavegador: e.usage ?? 0, cotaNavegador: e.quota ?? 0 };
  } catch { /* navegador antigo */ }
  return { livre: null, total: null, anexos: 0 };
}
